import LocationModel from "@/models/LocationModel";
import { service } from "@/services/app.service";
export var addressComponentMapper = {
    street_number: "streetNumber",
    route: "streetName",
    administrative_area_level_2: "county",
    locality: "locality",
    administrative_area_level_1: "state",
    country: "country",
    postal_code: "postalCode",
    subpremise: "aptNum"
};
var addressService = {
    rad: function (x) {
        return (x * Math.PI) / 180;
    },
    getLatLngDistance: function (p1, p2, convertToMiles) {
        if (convertToMiles === void 0) { convertToMiles = false; }
        var R = 6371; // Earth’s mean radius in meter
        var dLat = this.rad(p2.latitude - p1.latitude);
        var dLong = this.rad(p2.longitude - p1.longitude);
        // haversine
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.rad(p1.latitude)) *
                Math.cos(this.rad(p2.latitude)) *
                Math.sin(dLong / 2) *
                Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return convertToMiles ? R * c * 0.62137 : R * c;
    },
    isWithinRangeOfLocation: function (address, location, isPickUp) {
        if (isPickUp === void 0) { isPickUp = false; }
        var distance = Math.floor(this.getLatLngDistance({ latitude: address.latitude, longitude: address.longitude }, { latitude: location.latitude, longitude: location.longitude }, location.delivery.deliveryRadiusUnit === "miles"));
        return (isPickUp) ? distance < 20 : distance <= location.delivery.deliveryRadius;
    },
    getLastUsedAddress: function (addresses) {
        var lastUsedAddress = null;
        for (var _i = 0, addresses_1 = addresses; _i < addresses_1.length; _i++) {
            var address = addresses_1[_i];
            lastUsedAddress =
                (!lastUsedAddress && address.delivery.isDeliverable) ||
                    (lastUsedAddress.lastUsedDate < address.lastUsedDate && address.delivery.isDeliverable)
                    ? address
                    : lastUsedAddress;
        }
        return lastUsedAddress;
    },
    isAddressDeliverable: function (address, lb) {
        return service.get("/admin/squib_check_address", {
            params: {
                b: lb,
                address: address.formattedAddress,
                latitude: address.latitude,
                longitude: address.longitude
            }
        });
    },
    extractGPLaceProps: function (place) {
        var addressType = place.types[0];
        var newAddress = {};
        if (addressType === "street_address" ||
            (place.address_components["0"].types[0] === "street_number" && addressType === "premise")) {
            return {
                address: place.formatted_address,
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng()
            };
        }
        else {
            return null;
        }
    },
    isPointInPolygon: function (location, point) {
        for (var _i = 0, _a = location.delivery.deliveryRegions; _i < _a.length; _i++) {
            var region = _a[_i];
            var polygon = region.processedPoints;
            var n = polygon.length;
            var p1 = polygon[0];
            var c = 0;
            for (var i = 1; i <= n; i++) {
                var p2 = polygon[i % n];
                if (point.longitude > Math.min(p1.lng, p2.lng) &&
                    point.longitude <= Math.max(p1.lng, p2.lng) &&
                    point.latitude <= Math.max(p1.lat, p2.lat) &&
                    p1.lng !== p2.lng) {
                    var xinters = ((point.longitude - p1.lng) * (p2.lat - p1.lat)) / (p2.lng - p1.lng) + p1.lat;
                    if (p1.lat === p2.lat || point.latitude <= xinters) {
                        c++;
                    }
                }
                p1 = p2;
            }
            // if the number of edges we passed through is even, then it's not in the poly.
            return c % 2 !== 0;
        }
    },
    storeLocator: function (locations, address, isPickUp) {
        var _this = this;
        if (isPickUp === void 0) { isPickUp = false; }
        var foundStores = locations.reduce(function (result, location) {
            if (!(location instanceof LocationModel)) {
                location = new LocationModel(location);
            }
            // use point in polygon algo if possible, else straight line test
            if (location.delivery.hasDeliveryRegionsSet) {
                if (_this.isPointInPolygon(location, { latitude: address.latitude, longitude: address.longitude })) {
                    result.push(location);
                }
            }
            else if (_this.isWithinRangeOfLocation(address, location, isPickUp)) {
                result.push(location);
            }
            return result;
        }, []);
        return foundStores;
    },
    convertAddressComponents: function (addressComponents) {
        var addressComponentModel = {
            aptNum: {},
            locality: {},
            streetName: {},
            streetNumber: {},
            county: {},
            state: {},
            country: {},
            postalCode: {},
        };
        for (var _i = 0, addressComponents_1 = addressComponents; _i < addressComponents_1.length; _i++) {
            var component = addressComponents_1[_i];
            if (component.types) {
                for (var _a = 0, _b = component.types; _a < _b.length; _a++) {
                    var type = _b[_a];
                    if (addressComponentMapper[type]) {
                        addressComponentModel[addressComponentMapper[type]] = {
                            shortName: component.short_name,
                            longName: component.long_name
                        };
                        break;
                    }
                }
            }
        }
        return addressComponentModel;
    }
};
export default addressService;



//////////////////
// WEBPACK FOOTER
// ./src/services/address.service.ts
// module id = 4IyJ
// module chunks = 18